module.exports = __webpack_public_path__ + "2a4a480826255486d12577328572775b.jpg";